import { render } from "./AppLogoText.vue?vue&type=template&id=02b3034c"
import script from "./AppLogoText.vue?vue&type=script&lang=js"
export * from "./AppLogoText.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Evolve/WorkSpace/MinonowaRadio/Ver2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__